import { Bell, UserRound } from "lucide-react";

import { TESTIDS } from "@/lib/testids";

export default function GlobalAdminHeader() {
  return (
    <div
      className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-2 px-6 py-3"
      data-testid={TESTIDS.adminLayout.globalHeaderContent}
    >
      <div className="flex min-w-0 items-center gap-4">
        <span className="text-sm text-gray-400">Admin / Pilotage</span>
      </div>

      <div className="flex flex-wrap items-center gap-2">


        <button
          type="button"
          className="inline-flex h-9 items-center gap-2 rounded-md border border-white/10 px-3 text-sm text-slate-200 transition-colors hover:bg-white/5 hover:text-white"
          data-testid={TESTIDS.adminLayout.businessAlerts}
        >
          <Bell className="h-4 w-4" />
          Alertes
        </button>

        <button
          type="button"
          className="inline-flex h-9 items-center gap-2 rounded-md border border-white/10 px-3 text-sm text-slate-200 transition-colors hover:bg-white/5 hover:text-white"
          data-testid={TESTIDS.adminLayout.userMenu}
        >
          <UserRound className="h-4 w-4" />
          Admin
        </button>
      </div>
    </div>
  );
}
